import { FormattedMessage } from 'react-intl';
import React from 'react';

export const customersColumns = {
  state: {
    id: 'state',
    label: <FormattedMessage id={'app.pages.customerListPage.state'} />,
    width: '5%',
    align: 'left',
    options: {
      sortable: true,
      filterable: true,
    },
  },
  sapId: {
    id: 'idSap',
    label: <FormattedMessage id={'app.users.sapId'} />,
    width: '6%',
    align: 'left',
  },
  organizationName: {
    id: 'organizationName',
    label: <FormattedMessage id={'app.pages.customerListPage.organization'} />,
    width: '20%',
    align: 'left',
    options: {
      sortable: true,
    },
  },
  organizationNumber: {
    id: 'organizationNumber',
    label: <FormattedMessage id={'app.pages.customerListPage.customerID'} />,
    width: '15%',
  },
  kam: {
    id: 'kam',
    label: <FormattedMessage id={'app.pages.customerListPage.kam'} />,
    width: '15%',
    options: {
      sortable: true,
      filterable: true,
    },
  },
  representatives: {
    id: 'representatives',
    label: <FormattedMessage id={'app.pages.customerListPage.representatives'} />,
  },
  controls: {
    width: '10%',
    id: 'controls',
    label: '',
  },
};
